import React, { Component, useState } from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-animated-modal";
import { PulseLoader } from 'halogenium';
import { Bill } from '../../Model/Bill';

class PromoCodeListModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedPromoCode: null,
            setIsCheckingPromoCode: false,
        }
    }
    componentDidMount = () => {

    };

    componentDidUpdate = () =>{

    }

    // Parent to call this to dismiss the modal
    close() {
        this.props.onClose()
    }

    promoListing = () => {
        let normalData = this.props.data && this.props.data.length > 0 && this.props.data[0] || null
        let noStockData = this.props.data && this.props.data.length > 1 && this.props.data[1] || null
        let index = 0
        let orders = this.props.orders || []
        let gotTax = this.props.gotTax != null
        let serviceCharge = this.props.scPercent ? this.props.scPercent / 100 : 0;
        let extraSCstart = this.props.extraSCstart || null;
        let extraSCend = this.props.extraSCend || null;
        let extraSCName = this.props.extraSCName || null;
        let extraSCPercent = this.props.extraSCPercent;
        let extraSCValue = (extraSCPercent == null || extraSCPercent == 0) ? 0 : (extraSCPercent / 100.00);
        let deliveryCharge = this.props.deliveryCharge
        let fixedItem = <PromoCodeCard tableSession={this.props.tableSession} selectedPromoCode={this.props.selectedPromoCode} setPromoCodeError={this.props.selectedPromoCode} onClose={this.props.onClose} />
        let tableSession = this.props.tableSession
        let setPromoCodeError = this.props.selectedPromoCode
        const checkPromoCode2 = (val) => {
            this.state.setIsCheckingPromoCode = true
            $.ajax({
                url     : `/table_sessions/${tableSession.id}/use_promo_code/${val}`,
                type    : 'post',
                success : (res) => {
                    if (res) {
                        this.state.selectedPromoCode = null
                    }
                }
            })
            .fail(handlePromoCodeError2)
            .always(() => {
                this.state.setIsCheckingPromoCode = false
            })
        }

        const handlePromoCodeError2 = (xhr) => {
            if(xhr.responseJSON && xhr.responseJSON.message){
                if (setPromoCodeError) {
                    setPromoCodeError = xhr.responseJSON.message
                }
                else {
                    alert(xhr.responseJSON.message)
                }
            }
            return false
        }

        let roundTo = this.props.app.state.merchant.bill_round_to_nearest
        let normalDataMap = normalData ? normalData.map((promo) => {
            // order.item_name = me.getMenuItemName(order.menu_item_id);
            let listClass = "promo-code-" + promo.id;
            let formattedDate = moment(promo.expire_at).format("YYYY-MM-DD")
            let listedPromoCode = promo
            let billDetail = Bill.calculateBillDetailsForOrder({
                orders, isHasTax: gotTax, pickupTime: this.props.pickupTime, serviceCharge, extraSCstart, extraSCend, extraSCName, extraSCValue, deliveryCharge, promoCode: listedPromoCode, roundTo
            })
            let discountValue = billDetail.promo_code_discount
            let deliveryDiscount = billDetail.promo_code_delivery_discount
            let selectedPromoCode=promo.code
            index++;
            return (
                <div className={listClass} key={listClass}>
                    <li className={'list-group-item clearfix'} data-index={index} style={{ verticalAlign: "middle" }} key={promo.id} data-id={promo.id}>
                        <div className={'promo-list-info'}>
                            <h4>
                                <span>{promo.description}</span>
                                <span style={{ float: "right", color: "red" }}><b>- {this.props.currencyName}&nbsp; {parseFloat(billDetail.promo_code_discount-billDetail.rounding).toFixed(2)}</b></span>
                            </h4>
                            <p style={{fontSize: "12px"}}>Use Code: <b style={{fontSize: "14px"}}>{promo.code}</b></p>
                            <p style={{fontSize: "12px"}}>Expired at: {formattedDate}</p>
                            <p style={{fontSize: "12px"}}>Minimum Order: {this.props.currencyName}&nbsp; {promo.data[0].minimum_purchase_value}
                                {
                                        <button style={{ float: "right", marginTop: "-15px" }} className="btn btn-primary" onClick={() => {this.setState({selectedPromoCode: promo.code}); checkPromoCode2(promo.code); this.props.onClose()}} disabled={this.state.setIsCheckingPromoCode2}>
                                            {
                                                this.state.setIsCheckingPromoCode ?
                                                <span className="fa fa-spinner fa-spin"></span> :
                                                <span>Use</span>
                                            }
                                        </button>
                                }
                            </p>
                        </div>
                    </li>
                </div>
            )
        }) : null
        let noStockDataMap = noStockData ? noStockData.map((promo) => {
            // order.item_name = me.getMenuItemName(order.menu_item_id);
            let listClass = "promo-code-" + promo.id;
            let formattedDate = moment(promo.expire_at).format("YYYY-MM-DD")
            let listedPromoCode = promo
            let billDetail = Bill.calculateBillDetailsForOrder({
                orders, isHasTax: gotTax, pickupTime: this.props.pickupTime, serviceCharge, extraSCstart, extraSCend, extraSCName, extraSCValue, deliveryCharge, promoCode: listedPromoCode, roundTo
            })
            let discountValue = billDetail.promo_code_discount
            let deliveryDiscount = billDetail.promo_code_delivery_discount
            let selectedPromoCode=promo.code
            index++;
            return (
                <div className={listClass} key={listClass}>
                    <li className={'list-group-item clearfix'} data-index={index} style={{ verticalAlign: "middle" }} key={promo.id} data-id={promo.id}>
                        <div className={'promo-list-info'}>
                            <h4>
                                <span>{promo.description}</span>
                                <span style={{ float: "right", color: "red" }}><b>- {this.props.currencyName}&nbsp; {parseFloat(billDetail.promo_code_discount-billDetail.rounding).toFixed(2)}</b></span>
                            </h4>
                            <p style={{fontSize: "12px"}}>Use Code: <b style={{fontSize: "14px"}}>{promo.code}</b></p>
                            <p style={{fontSize: "12px"}}>Expired at: {formattedDate}</p>
                            <p style={{fontSize: "12px"}}>Minimum Order: {this.props.currencyName}&nbsp; {promo.data[0].minimum_purchase_value}
                                {
                                    <button style={{ float: "right", marginTop: "-15px" }} className="btn btn-primary" disabled={true}>
                                        {
                                            <span>Use</span>
                                        }
                                    </button>
                                }
                            </p>
                        </div>
                    </li>
                </div>
            )
        }) : null
        let noStockDataDiv = noStockData != null ? <div>
                            <p style={{ fontSize: "16px" }}><b> Temporary Unavailable </b></p>
                            <div style={{ backgroundColor: "white", opacity: "0.8" }}>
                            {noStockDataMap}
                            </div>
                        </div> : null
        return (
                    <div className="menu-modal" style={{padding:"20px"}}>
                        <div>
                            <p style={{ fontSize: "16px" }}><b> Popular Promo Codes </b></p>
                            {fixedItem}
                            {normalDataMap}
                        </div>
                        <br />
                            {noStockDataDiv}
                        <div>

                        </div>
                    </div>
        )
    }

    render() {
        return (
                <Modal
                    visible={true}
                    closemodal={this.props.onClose}
                    type="pulse">
                    {this.promoListing()}
                </Modal>
        )
    }
}
function PromoCodeCard({ app, tableSession, onChangeOrderModeClicked, setPromoCodeError, selectedPromoCode, onClose }) {
    const [promoCodeStr, setPromoCodeStr] = useState("")
    const [isCheckingPromoCode, setIsCheckingPromoCode] = useState(false)
    const checkPromoCode = () => {
        setIsCheckingPromoCode(true)
        $.ajax({
            url     : `/table_sessions/${tableSession.id}/use_promo_code/${promoCodeStr}`,
            type    : 'post',
            success : (res) => {
                if (res) {
                    setPromoCodeStr("")
                    onClose()
                }
            }
        })
        .fail(handlePromoCodeError)
        .always(() => {
            setIsCheckingPromoCode(false)
        })
    }

    const handlePromoCodeError = (xhr) => {
        if(xhr.responseJSON && xhr.responseJSON.message){
            if (setPromoCodeError) {
                setPromoCodeError(xhr.responseJSON.message)
            }
            else {
                alert(xhr.responseJSON.message)
            }
        }
        return false
    }

    return <div style={{ padding: '10px', marginBottom: "20px", backgroundColor: "white" }}>
        <div className="form-group row">
            <label htmlFor="order-type" className="col-sm-3 col-form-label">{lang.promo_code}</label>
            <div className="col-sm-9">
                <div style={{ display: "flex" }}>
                    <div style={{ flex: "1 0 50px" }}>
                        <input type="text" className="form-control" value={promoCodeStr} onChange={(e) => setPromoCodeStr(e.target.value)}/>
                    </div>
                    {
                        <div style={{ flex: "1 0 50px", textAlign: "right" }}>
                            <button className="btn btn-default" onClick={checkPromoCode} disabled={isCheckingPromoCode || !promoCodeStr}>
                                {
                                    isCheckingPromoCode ?
                                    <span className="fa fa-spinner fa-spin"></span> :
                                    <span>Use Code</span>
                                }
                            </button>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}
export default PromoCodeListModal;